var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paper layout-main",style:({height: (_vm.screenHeight - 64) + 'px'})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }